import styled from "styled-components";

export const Main = styled.div`
  width: 100%;
  max-width: 1366px;
  background-color: white;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
  margin-top: 24px;
  border-radius: 8px;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);
`;

export const SectionTitle = styled.h2`
  font-weight: 700;
  font-size: 1.25rem;
  color: #1E1B39;
  margin: 0;
`;

export const SplitRow = styled.div`
  display: flex;
  gap: 30px;
`;
